import React from "react";
import {Alert, Snackbar} from "@mui/material";

export default function FeedbackSnackbar({
    feedback,
    onClose,
    autoHideDuration = 5000,
    anchorOrigin = {vertical: 'top', horizontal: 'right'},
}) {
    const severity = feedback?.error ? 'error' : feedback?.success ? 'success' : null;
    const message = feedback?.error || feedback?.success || '';

    const handleClose = (_, reason) => {
        if (reason === 'clickaway') return;
        onClose?.();
    };

    return (
        <Snackbar
            open={Boolean(message)}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            anchorOrigin={anchorOrigin}
        >
            <Alert
                onClose={handleClose}
                severity={severity || 'info'}
                variant="filled"
                sx={{width: '100%', minWidth: 320, boxShadow: 3}}
            >
                {message}
            </Alert>
        </Snackbar>
    );
}
